type LoaderProps = {
    contained?: boolean; // Add this prop
};

const Loader: React.FC<LoaderProps> = ({ contained = false }) => {
    return (
        <>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>

            <div 
                style={{
                    ...styles.loadingOverlay,
                    // If contained, use 'absolute' to stick to parent. 
                    // If not, use 'fixed' to cover the whole screen/window.
                    position: contained ? "absolute" : "fixed", 
                    
                    // Optional: If contained, you might want to round corners to match parent
                    borderRadius: contained ? "inherit" : "0", 
                }}
            >
                <div style={styles.loadingSpinner}></div>
            </div>
        </>
    );
};

export default Loader;

const styles: { [key: string]: React.CSSProperties } = {
    loadingOverlay: {
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(5px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
    },
    loadingSpinner: {
        width: "50px",
        height: "50px",
        border: "5px solid transparent",
        borderTop: "5px solid #fff",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
    },
};